/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import Util from './util';
/*
 * Add the CSRF header (if we have one cached) to requests that may need it.
 * @namespace Ajax.Csrf
 */

var Write = /*#__PURE__*/function () {
  function Write(cache, nextAjax) {
    this.ajax = this.ajax.bind(this);
    this.nextAjax = nextAjax;

    if (!cache.csrf) {
      cache.csrf = {};
    }

    this.tokens = cache.csrf.tokens || (cache.csrf.tokens = {});
  }

  var _proto = Write.prototype;

  _proto.ajax = function ajax(options) {
    var host = Util.hostFromUrl(options.url);

    if (Util.requiresCsrfToken(this.tokens, options) && this.tokens[host]) {
      if (!options.headers) {
        options.headers = {};
      }

      options.headers['X-CSRF-Token'] = this.tokens[host];
    }

    return this.nextAjax(options);
  };

  return Write;
}();

export default Write;